import React from 'react';
import { NavLink } from 'react-router';
import { Row } from '../../../../components/base/BootstrapComponents/BootstrapComponents';
import { dateFormatter, infoFormatterIntl, localeFormatter } from '../../../../utils/formatters';
import { PROCEDURE_TYPE } from '../../../../configs';
import FileView from '../../../../components/fields/FileInput/FileView';

export default function CarView(prop) {
  const {
    data, procedure, prefix = '', fieldsValidation, currentApplication,
  } = prop;
  const {
    vehicle_brand,
    vehicle_model,
    vehicle_year,
    vehicle_color,
    vehicle_lpn,
    vehicle_vin,
    vehicle_registration_number,
    vehicle_registration_issue_date,
    ecology_class,
    has_special_lifting_device,
    tech_control_address,
    ownership_type,
    ownership_contract_number,
    ownership_contract_effective_date,
    ownership_contract_expiration_date,
    ownership_contract_name,
    vehicle_number,
  } = data;

  const files = currentApplication?.files || [];
  const ownership_contract_files = files && files.length ? files.find(item => item.collection_name === 'ownership_contract_files') : undefined;
  const applicant_car_cd_file = files && files.length ? files.find(item => item.collection_name === 'applicant_car_cd_file') : undefined;
  const car_photo_file = files && files.length ? files.find(item => item.collection_name === 'car_photo_file') : undefined;

  return (
    <>
      <Row className="row-cols-3">
        {infoFormatterIntl('vehicle_brand', vehicle_brand, fieldsValidation, `${prefix}vehicle_brand`)}
        {infoFormatterIntl('vehicle_model', vehicle_model, fieldsValidation, `${prefix}vehicle_model`)}
        {infoFormatterIntl('vehicle_lpn', vehicle_lpn, fieldsValidation, `${prefix}vehicle_lpn`)}
      </Row>
      <Row className="row-cols-3">
        {infoFormatterIntl('vehicle_vin', vehicle_vin, fieldsValidation, `${prefix}vehicle_vin`)}
        {procedure === PROCEDURE_TYPE.PROCEDURE_kt_exlt
          ? infoFormatterIntl('applicant_car_cd_file', applicant_car_cd_file ? <FileView readOnly withoutMime withoutHr files={[applicant_car_cd_file]} /> : null, fieldsValidation, '', 4) : null }
        {procedure !== PROCEDURE_TYPE.PROCEDURE_kt_exlt
          ? (
            <>
              {infoFormatterIntl('vehicle_year', vehicle_year, fieldsValidation, `${prefix}vehicle_year`)}
              {infoFormatterIntl('vehicle_color', vehicle_color, fieldsValidation, `${prefix}vehicle_color`)}
            </>
          ) : null }
      </Row>
      {procedure !== PROCEDURE_TYPE.PROCEDURE_kt_exlt
        ? (
          <>
            <Row className="row-cols-1">
              {infoFormatterIntl('ecology_class', localeFormatter('ecology-class', ecology_class), fieldsValidation, `${prefix}ecology_class`)}
            </Row>
            <div className="f4 mt-3">Сведения о СТС</div>
            <Row className="row-cols-2">
              {infoFormatterIntl('vehicle_registration_number', vehicle_registration_number, fieldsValidation, `${prefix}vehicle_registration_number`)}
              {infoFormatterIntl('vehicle_registration_issue_date', dateFormatter(vehicle_registration_issue_date), fieldsValidation, `${prefix}vehicle_registration_issue_date`)}
            </Row>
            {procedure !== PROCEDURE_TYPE.PROCEDURE_1227_8 ? (
              <Row className="row-cols-1">
                {infoFormatterIntl('has_special_lifting_device', has_special_lifting_device ? 'Есть' : 'Нет', fieldsValidation, `${prefix}has_special_lifting_device`)}
              </Row>
            ) : null}
            <Row className="row-cols-3">
              {infoFormatterIntl('ownership_type', localeFormatter('ownership.type', ownership_type), fieldsValidation, `${prefix}ownership_type`)}
              {infoFormatterIntl('applicant_car_cd_file', applicant_car_cd_file ? <FileView readOnly withoutMime withoutHr files={[applicant_car_cd_file]} /> : null, fieldsValidation, '', 4)}
              {infoFormatterIntl('car_photo_file', car_photo_file ? <FileView readOnly withoutMime withoutHr files={[car_photo_file]} /> : null, fieldsValidation, '', 4)}
            </Row>
            <div className="f4 mt-3">Информация о договоре</div>
            <Row className="row-cols-2">
              {infoFormatterIntl('ownership_contract_number', ownership_contract_number, fieldsValidation, `${prefix}ownership_contract_number`)}
              {infoFormatterIntl('ownership_contract_effective_date', dateFormatter(ownership_contract_effective_date), fieldsValidation, `${prefix}ownership_contract_effective_date`)}
            </Row>
            <Row className="row-cols-2">
              {infoFormatterIntl('ownership_contract_expiration_date', dateFormatter(ownership_contract_expiration_date), fieldsValidation, `${prefix}ownership_contract_expiration_date`)}
              {infoFormatterIntl('ownership_contract_files', ownership_contract_files ? <FileView readOnly withoutMime withoutHr files={[ownership_contract_files]} /> : null, fieldsValidation, '', 6)}
            </Row>
          </>
        ) : null }
    </>
  );
}
